// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-not-found-page {
  min-height: 100vh;
  background: linear-gradient(135deg, 
    rgba(255, 255, 100, 0.05) 0%, 
    rgba(255, 165, 0, 0.05) 50%, 
    rgba(50, 205, 50, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  font-family: 'Segoe UI', sans-serif;
}

.not-found-container {
  max-width: 500px;
  width: 100%;
  text-align: center;
  padding: 3rem 2rem;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.error-icon {
  font-size: 4rem;
  color: #ff6b6b;
  margin-bottom: 1.5rem;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.error-title {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ff6b6b, #ffa500);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.error-message {
  color: rgba(0, 0, 0, 0.7);
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.room-id-highlight {
  font-weight: 600;
  color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
}

.countdown-section {
  margin: 2rem 0;
}

.countdown-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffa500, #ffff64);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 
    0 4px 20px rgba(255, 165, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  animation: countdown-pulse 1s infinite;
}

@keyframes countdown-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 
      0 4px 20px rgba(255, 165, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 
      0 6px 25px rgba(255, 165, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
  }
}

.countdown-number {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.countdown-section p {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1rem;
  margin: 0;
}

.action-buttons {
  margin: 2rem 0;
}

.crystal-btn {
  background: linear-gradient(135deg, #32cd32, #228b22);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 
    0 4px 15px rgba(50, 205, 50, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.crystal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 6px 20px rgba(50, 205, 50, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.crystal-btn:active {
  transform: translateY(0);
}

.crystal-btn.large {
  padding: 1.2rem 2.5rem;
  font-size: 1.2rem;
}

.suggestions {
  margin-top: 2rem;
  text-align: left;
}

.suggestions h3 {
  color: rgba(0, 0, 0, 0.7);
  font-size: 1.2rem;
  margin-bottom: 1rem;
  text-align: center;
}

.suggestions ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestions li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 0.5rem;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
}

.suggestions li:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(5px);
}

.suggestions li i {
  color: #32cd32;
  font-size: 1.1rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .room-not-found-page {
    padding: 1rem;
  }
  
  .not-found-container {
    padding: 2rem 1.5rem;
  }
  
  .error-title {
    font-size: 2rem;
  }
  
  .error-icon {
    font-size: 3rem;
  }
  
  .countdown-circle {
    width: 60px;
    height: 60px;
  }
  
  .countdown-number {
    font-size: 1.5rem;
  }
  
  .crystal-btn.large {
    padding: 1rem 2rem;
    font-size: 1.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/RoomNotFoundPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB;;;iCAG+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C;;0CAEwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB;;0CAEwC;EACxC,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;IACnB;;4CAEwC;EAC1C;EACA;IACE,sBAAsB;IACtB;;4CAEwC;EAC1C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB;;0CAEwC;EACxC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".room-not-found-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, \n    rgba(255, 255, 100, 0.05) 0%, \n    rgba(255, 165, 0, 0.05) 50%, \n    rgba(50, 205, 50, 0.05) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  font-family: 'Segoe UI', sans-serif;\n}\n\n.not-found-container {\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  padding: 3rem 2rem;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: \n    0 8px 32px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.error-icon {\n  font-size: 4rem;\n  color: #ff6b6b;\n  margin-bottom: 1.5rem;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n.error-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #ff6b6b, #ffa500);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.error-message {\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n}\n\n.room-id-highlight {\n  font-weight: 600;\n  color: #ff6b6b;\n  background: rgba(255, 107, 107, 0.1);\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n}\n\n.countdown-section {\n  margin: 2rem 0;\n}\n\n.countdown-circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffa500, #ffff64);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n  box-shadow: \n    0 4px 20px rgba(255, 165, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  animation: countdown-pulse 1s infinite;\n}\n\n@keyframes countdown-pulse {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: \n      0 4px 20px rgba(255, 165, 0, 0.3),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: \n      0 6px 25px rgba(255, 165, 0, 0.4),\n      inset 0 1px 0 rgba(255, 255, 255, 0.4);\n  }\n}\n\n.countdown-number {\n  font-size: 2rem;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.countdown-section p {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 1rem;\n  margin: 0;\n}\n\n.action-buttons {\n  margin: 2rem 0;\n}\n\n.crystal-btn {\n  background: linear-gradient(135deg, #32cd32, #228b22);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: \n    0 4px 15px rgba(50, 205, 50, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.crystal-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: \n    0 6px 20px rgba(50, 205, 50, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.crystal-btn:active {\n  transform: translateY(0);\n}\n\n.crystal-btn.large {\n  padding: 1.2rem 2.5rem;\n  font-size: 1.2rem;\n}\n\n.suggestions {\n  margin-top: 2rem;\n  text-align: left;\n}\n\n.suggestions h3 {\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.suggestions ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.suggestions li {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  color: rgba(0, 0, 0, 0.6);\n  transition: all 0.3s ease;\n}\n\n.suggestions li:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateX(5px);\n}\n\n.suggestions li i {\n  color: #32cd32;\n  font-size: 1.1rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .room-not-found-page {\n    padding: 1rem;\n  }\n  \n  .not-found-container {\n    padding: 2rem 1.5rem;\n  }\n  \n  .error-title {\n    font-size: 2rem;\n  }\n  \n  .error-icon {\n    font-size: 3rem;\n  }\n  \n  .countdown-circle {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .countdown-number {\n    font-size: 1.5rem;\n  }\n  \n  .crystal-btn.large {\n    padding: 1rem 2rem;\n    font-size: 1.1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
